/**
 * Logging service
 *
 * Used to present UserLog records from the backend in a format that is more readable;
 * Userlogs store the entire record on each update, but display them as a series of changes.
 * This service performs that conversion.
 *
 */
export default {
    formattedEntries (entries) {
        //Create a 'content' entry from a json parse of the text
        entries = entries.map((entry) => {
            entry.json = JSON.parse(entry.json)
            return entry
        })

        let lastUpdateEntry = null
        entries.forEach((entry, index) => {

            if (entry.action === 'update') {
                entries[index].text = this.formatUpdate(entries[index], lastUpdateEntry)
                lastUpdateEntry = entries[index]
            }
        })

        return entries
    },

    formatUpdate (entry, lastUpdateEntry) {
        let text = ''
        let diffKeys = this.diffKeys(entry, lastUpdateEntry)

        diffKeys.forEach((key) => {
            if (typeof entry.json[key] !== 'object') {
                text += 'Updated ' + this.formatKey(key) + " to '" +
                    this.formatKey(entry.json[key]) + "'\n "
            }
        })
        return text
    },

    formatKey (key) {
        if (typeof key === 'string') {
            return key.toLowerCase().replace('_', ' ')
        } else {
            return key
        }
    },

    diffKeys (entry, prevEntry) {
        if (!prevEntry) {
            return []
        }

        let diffKeys = []
        Object.keys(entry.json).forEach((key) => {
            if (JSON.stringify(entry.json[key]) !==
                JSON.stringify(prevEntry.json[key])) {
                diffKeys.push(key)
            }
        })
        return diffKeys
    }

}